module.exports = __webpack_public_path__ + "static/media/phone.efb56476.png";